/**
 * Sticky Bundle Cart functionality
 * Shows a sticky cart bar when scrolling down on bundle product pages
 */

class StickyBundleCart {
  constructor() {
    this.stickyCart = document.getElementById('sticky-bundle-cart');
    this.selectedVariantElement = document.getElementById('sticky-selected-variant');
    this.currentPriceElement = document.querySelector('.sticky-bundle-cart__current-price');
    this.originalPriceElement = document.querySelector('.sticky-bundle-cart__original-price');
    this.buttonElement = document.querySelector('.sticky-bundle-cart__button');
    this.variantImageElement = document.querySelector('.sticky-bundle-cart__image img');
    
    if (!this.stickyCart) return;
    
    this.init();
  }

  init() {
    this.bindEvents();
    this.handleScroll();
  }

  bindEvents() {
    // Listen for scroll events
    window.addEventListener('scroll', this.handleScroll.bind(this));
    
    // Listen for variant changes
    document.addEventListener('variant:change', this.handleVariantChange.bind(this));
    
    // Listen for form submission
    const productForm = document.querySelector('product-form form');
    if (productForm) {
      productForm.addEventListener('submit', this.handleFormSubmit.bind(this));
    }
  }

  handleScroll() {
    if (!this.stickyCart) return;
    
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const triggerPoint = 300; // Show after 300px scroll
    
    if (scrollTop > triggerPoint) {
      this.stickyCart.classList.add('sticky-bundle-cart--visible');
    } else {
      this.stickyCart.classList.remove('sticky-bundle-cart--visible');
    }
  }

  handleVariantChange(event) {
    if (!event.detail || !event.detail.variant) return;
    
    const variant = event.detail.variant;
    
    // Update variant name
    if (this.selectedVariantElement) {
      this.selectedVariantElement.textContent = variant.title;
    }
    
    // Update variant image
    if (this.variantImageElement && variant.image) {
      this.variantImageElement.src = variant.image;
      this.variantImageElement.alt = variant.title;
    }
    
    // Update prices
    if (this.currentPriceElement) {
      this.currentPriceElement.textContent = this.formatMoney(variant.price);
    }
    
    if (this.originalPriceElement) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        this.originalPriceElement.textContent = this.formatMoney(variant.compare_at_price);
        this.originalPriceElement.style.display = 'inline';
      } else {
        this.originalPriceElement.style.display = 'none';
      }
    }
    
    // Update button state
    if (this.buttonElement) {
      if (variant.available) {
        this.buttonElement.disabled = false;
        this.buttonElement.textContent = window.theme.strings.addToCart || 'Add to cart';
      } else {
        this.buttonElement.disabled = true;
        this.buttonElement.textContent = window.theme.strings.soldOut || 'Sold out';
      }
    }
  }

  handleFormSubmit(event) {
    // Add loading state to sticky button
    if (this.buttonElement) {
      this.buttonElement.disabled = true;
      this.buttonElement.textContent = window.theme.strings.addingToCart || 'Adding...';
      
      // Add bounce animation
      this.buttonElement.classList.add('bounce');
      setTimeout(() => {
        this.buttonElement.classList.remove('bounce');
      }, 600);
    }
  }

  formatMoney(cents) {
    // Simple money formatting - you might want to use Shopify's money format
    const dollars = (cents / 100).toFixed(2);
    return `$${dollars}`;
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new StickyBundleCart();
});

// Also initialize if DOM is already loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new StickyBundleCart();
  });
} else {
  new StickyBundleCart();
} 